export const getFoodModalSteps = (t) => [
    {
        target: '[data-tour="fm-modal"]',
        placement: 'center',
        title: t('tour.foodModal.step-welcome-title'),
        content: t('tour.foodModal.step-welcome-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="fm-names"]',
        title: t('tour.foodModal.step-names-title'),
        content: t('tour.foodModal.step-names-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="fm-general"]',
        title: t('tour.foodModal.step-general-title'),
        content: t('tour.foodModal.step-general-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="fm-macros"]',
        title: t('tour.foodModal.step-macros-title'),
        content: t('tour.foodModal.step-macros-content'),
        disableBeacon: true,
    },
    {
        target: '[data-tour="fm-footer"]',
        title: t('tour.foodModal.step-footer-title'),
        content: t('tour.foodModal.step-footer-content'),
        disableBeacon: true,
    },
];
